import { Flex, Icon, Input } from '@chakra-ui/react';
import { RiSearchLine } from 'react-icons/ri';
import { search } from 'ss-search';

type ControlsData = {
  page: number;
  perPage: number;
  totalPage: number;
};
type VendaData = {
	agendamento: boolean;
	campanha: string;
	cupom: { id_desconto: string; type_desc: string; valor: string };
	distance: number;
	duration: number;
	endereco_entrega: EnderecoData;
	formatted_address: string;
	hora_agendada: string;
	cliente: {
		id: string;
		nome: string;
		doc: string;
		phone: string;
		cid: string;
	};
	id_order: number;
	items: ItemData[];
	merchant_id: number;
	mesa: boolean;
	mesa_number: string;
	mesa_token: string;
	order_data: string;
	order_status: string;
	pagamentos: PagamentoData[];
	prev_entrega: string;
	retirar: boolean;
	subTotal: number;
	taxa_entrega: number;
	taxa_service: number;
	tempo_preparo: number;
	tempo_preparo_str: string;
	total: number;
	totalFormatted: string;
	total_merchant: number;
}
type EnderecoData = {
	bai: string;
	cep: string;
	cid: string;
	cidcod: string;
	comp: string;
	distace: {
		distance: { value: number };
		duration: { value: number };
	};
	endereco: string;
	formatted_address: string;
	id: string;
	location: { lat: number; lng: number };
	num: string;
	ponto_ref: string;
	uf: string;
}
type PagamentoData = {
	band_pay: string;
	chave_pay: string;
	currency_pay: string;
	id_pay: number;
	method_pay: string;
	name_pay: string;
	tipchave_pay: string;
	trocoFormatted: string;
	troco_para: number;
	type_pay: string;
	url_pay: string;
}
type ItemData = {
	cod_barras: string;
	complementos: ComplementoData[];
	descricao: string;
	id: string;
	nome: string;
	obs: string;
	promocao: string;
	qtd: number;
	total: number;
	totalFormatted: string;
	url_imagem: string;
	valor: number;
	valorFormatted: string;
}
type ComplementoData = {
	codigo: string;
	descricao: string;
	grupo: string;
	nome: string;
	priceFormatted: string;
	qtd: number;
	qtd_gratis: number;
	qtd_maxima: number;
	valor: number;
}
interface DataTableSearchParams {
  vendas: VendaData[];
  setPesqVendas: (vendas: VendaData[]) => void;
  controls: ControlsData;
  setControls: (control: ControlsData) => void;
  handleUpdateList: (
    page: number,
    perPage: number,
    vendas: VendaData[],
  ) => void;
}

const DataTableSearch: React.FC<DataTableSearchParams> = ({
  vendas,
  setPesqVendas,
  controls,
  setControls,
  handleUpdateList,
}) => {
  function handlePesquisa(text: string) {
    if (text === '' || text === ' ') {
			setPesqVendas(vendas);

      setControls({
        ...controls,
        page: 1,
				totalPage: Math.ceil(vendas.length / controls.perPage),
      });
			handleUpdateList(1, controls.perPage, vendas);
      return;
    }

		const searchKeys = [
			'order_status',
			'id_order',
			'cliente.nome',
			'cliente.id',
			'order_data',
			'nome_cliente',
			'total',
			'items[nome]',
			'items[complementos.nome]',
		];
		const results = search(vendas, searchKeys, text) as VendaData[];

		setPesqVendas(results);
    setControls({
      ...controls,
      page: 1,
      totalPage: Math.ceil(results.length / controls.perPage),
    });

    handleUpdateList(1, controls.perPage, results);
  }

  return (
		<Flex as="form" ml={["0", "0", "4"]}>
      <Flex
        as="label"
        flex="1"
        py="2"
        pl="2"
        pr="6"
				mb={4}
        maxWidth={400}
        alignSelf="center"
        color="gray.900"
        position="relative"
        bg="gray.50"
        borderRadius="full"
      >
        <Input
          color="gray.900"
          variant="unstyled"
          px="4"
          mr="4"
          placeholder="Pesquisar"
          _placeholder={{ color: 'gray.400' }}
          onChange={e => handlePesquisa(e.target.value)}
        />

        <Icon as={RiSearchLine} fontSize="20" color="blue.500" />
      </Flex>
    </Flex>
  );
};

export default DataTableSearch;
